import { environment } from '../environments/environment';

/**
 * Utility class for URL-related operations.
 */
export class UrlUtils {

    /**
     * Converts a relative image URL to a full URL using the API base URL.
     * If the URL is already absolute (starts with http:// or https://), returns it unchanged.
     * Returns null if the input is null or undefined.
     *
     * @param imageUrl - The image URL to convert (can be relative like /api/v1/files/abc.jpg)
     * @returns The full URL or null if input is null/undefined
     */
    public static getFullImageUrl(imageUrl: string | null | undefined): string | null {
        if (!imageUrl) {
            return null;
        }
        if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
            return imageUrl;
        }
        // Remove /api/vX suffix from apiUrl to get base URL
        const baseUrl = environment.apiUrl.replace(/\/api\/v\d+$/, '');
        return baseUrl + imageUrl;
    }
}
